module.exports = __webpack_public_path__ + "media/images/athletes/1982-21df9b5828366b55b647badf7fd96c2c.png";